/**
 * Dashboard Utility Functions
 *
 * This file contains helper functions and utilities for the Dashboard component.
 */

import type { FilterOption } from '../types/DashboardTypes';

/**
 * Gets the display name for a selected filter option
 * @param options - Array of filter options
 * @param selectedId - Currently selected option ID
 * @returns Display name of the selected option
 */
export const getSelectedOptionName = (options: FilterOption[], selectedId: string): string => {
    const option = options.find(opt => opt.id === selectedId);
    return option?.name || selectedId;
};

/**
 * Formats comparison label with prefix
 * @param comparisonName - Name of comparison option
 * @returns Formatted comparison label
 */
export const formatComparisonLabel = (comparisonName: string): string => {
    return `Compare to: ${comparisonName}`;
};
